import React, { useState, useEffect } from "react";
import GlobalSVG from "../../utils/GlobalSVG";
import deleteIcon from "../../assets/delete.png";
import API from "../../utils/API";
import Swal from "sweetalert2";
import { useLocation } from 'react-router-dom';

const mockServices = [
    "Trocar farol", "Lavar", "Trocar pneus", "Revisão completa", "Trocar óleo"
];

function ChecklistPage() {
    const [selectedDetail, setSelectedDetail] = useState("Dianteira");
    const [inputValue, setInputValue] = useState('');
    const [suggestedServices, setSuggestedServices] = useState([]);
    const [services, setServices] = useState({
        "service_id": "",
        "Dianteira": [],
        "Traseira": [],
        "Topo": [],
        "Plataforma": [],
        "Direita": [],
        "Esquerda": [],
        "Interno": []
    });

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    let query = useQuery();
    let id = query.get('id');

    const finalizeOS = () => {
        Swal.fire({
            title: 'Tem certeza que deseja finalizar a OS?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Finalizando OS',
                    text: 'Aguarde um momento',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })
                API.finalizeOS(API.cancelToken(), id,).then(res => {
                    Swal.close()
                    window.location.href = '/services'
                }).catch(err => {
                    console.log(err)
                    Swal.fire({
                        title: 'Erro ao finalizar OS',
                        text: 'Tente novamente mais tarde',
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                })
            }
        })
    }

    useEffect(() => {

        if (!localStorage.getItem('yc_usr_dt_ls')) {
            window.location.href = '/login';
        }
        
        Swal.fire({
            title: 'Carregando serviços',
            text: 'Aguarde um momento',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })
        API.getServiceDetail(API.cancelToken(), id).then(res => {
            console.log(res.data)
            setServices(res.data)
            Swal.close()
        }).catch(err => {
            console.log(err)
            Swal.fire({
                title: 'Erro ao carregar serviços',
                text: 'Tente novamente mais tarde',
                icon: 'warning',
                confirmButtonText: 'OK'
            })
        })
    }, [])

    useEffect(() => {
        if (inputValue) {
            setSuggestedServices(mockServices.filter(service => service.toLowerCase().includes(inputValue.toLowerCase())));
        } else {
            setSuggestedServices([]);
        }
    }, [inputValue]);

    const handleAddService = () => {
        // Ensure there's a non-empty inputValue and the service isn't already added
        if (inputValue.trim() && !services[selectedDetail].some(service => service.item === inputValue)) {
            const newService = {
                service: inputValue,
                annotation: ""  // Initialize with an empty annotation
            };
            const updatedServices = { ...services, [selectedDetail]: [...services[selectedDetail], newService] };
            setServices(updatedServices);
            setInputValue(''); // Clear the input after adding the service
        }
    };

    const handleChange = (index, event) => {
        let name = event.target.name;
        const updatedServices = { ...services };
        // if (name === "service") {
        updatedServices[selectedDetail][index][name] = event.target.value;
        // } else {
        //     updatedServices[selectedDetail][index].annotation = event.target.value;
        // }
        setServices(updatedServices);
    };

    const handleDelete = (index) => {
        const updatedServices = services[selectedDetail].filter((_, idx) => idx !== index);
        setServices({ ...services, [selectedDetail]: updatedServices });
    };

    const moveOn = () => {
        console.log(services)
        Swal.fire({
            title: 'Salvando serviços',
            text: 'Aguarde um momento',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })
        API.postServiceItem(API.cancelToken(), services, "YES").then(res => {
            localStorage.setItem('service_items', JSON.stringify(services))
            Swal.close()
        }).catch(err => {
            console.log(err)
            Swal.fire({
                title: 'Erro ao salvar serviços',
                text: 'Tente novamente mais tarde',
                icon: 'warning',
                confirmButtonText: 'OK'
            })
        })
    }

    return (
        <div className="flex flex-col px-11 py-4 items-center self-stretch bg-white rounded-sm shadow-sm max-md:px-5 max-md:max-w-full ">
            <div className="flex pb-2 flex-col items-start gap-2.5 self-stretch">
                <p className="text-2xl font-medium">Checklist</p>
            </div>
            <div className="flex flex-col items-center gap-6 self-stretch">
                {/* Selection bar */}
                <div className="flex flex-col h-12 justify-end items-center self-stretch">
                    <div className="flex items-end gap-8 flex-1">
                        {["Dianteira", "Traseira", "Topo", "Plataforma", "Direita", "Esquerda", "Interno"].map(area => (
                            <div key={area} className={`flex justify-center py-2 px-1 items-center gap-3 flex-1 cursor-pointer border-b-2 ${selectedDetail === area ? "border-[#237804]" : "border-[#000000D9]"} `}
                                onClick={() => setSelectedDetail(area)}>
                                {GlobalSVG.antDesign(selectedDetail === area ? "#237804" : "#000000D9")}
                                <p className={`${selectedDetail === area ? "text-[#237804]" : "text-[#000000D9]"}`}>{area}</p>
                            </div>
                        ))}
                    </div>
                </div>
                {/* Autocomplete and button */}
                <div className="flex justify-start items-center gap-4 self-stretch">
                    <div className="w-60 h-full flex">
                        <div className="relative w-full">
                            <input
                                type="text"
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                                className="border border-gray-300 rounded-sm pl-5 pr-4 py-1 focus:outline-none focus:ring-blue-500 focus:border-blue-500 w-full"
                                placeholder="Buscar um item..."
                            />
                            <div className="absolute w-auto h-auto inset-y-0 right-0 p-2.5 flex items-center justify-center gap-2 self-stretch pointer-events-none">
                                {GlobalSVG.search()}
                            </div>
                        </div>
                        <div className="flex flex-col absolute top-full mt-1 bg-white border border-gray-300 z-10">
                            {suggestedServices.map(service => (
                                <div key={service} className="px-4 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => setInputValue(service)}>{service}</div>
                            ))}
                        </div>
                    </div>
                    <div className="flex h-auto w-auto px-4 py-1 justify-center items-center bg-[#389E0D] gap-2.5 border border-[#389E0D] rounded shadow-sm  cursor-pointer" onClick={handleAddService}>
                        <p className="text-[#FFF] whitespace-nowrap">Adicionar Serviço</p>
                    </div>
                </div>
                {/* Display added services */}
                <div className="w-full p-4">
                    {services[selectedDetail].map((service, index) => (
                        <div key={index} className="flex flex-col p-2 bg-gray-100 rounded-md mb-2">
                            <div className="flex mb-5 items-center">
                                <div className="flex flex-col mr-5 w-2/3">
                                    <label className="align-bottom w-36 font-semibold mr-2">Serviço a fazer:</label>
                                    <input className="p-2  border border-gray-300 rounded-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 w-full" name='service' value={service.service} onChange={(e) => handleChange(index, e)}></input>

                                </div>
                                <div className="flex flex-col mr-5">
                                    <label className="align-bottom font-semibold mr-2">Valor da Peça:</label>
                                    <input className="p-2 border border-gray-300 rounded-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 w-full" name='part_price' type="number" value={service.part_price} onChange={(e) => handleChange(index, e)}></input>
                                </div>
                                <div className="flex flex-col">
                                    <label className="align-bottom w-36 font-semibold mr-2">Valor do Serviço:</label>
                                    <input type="number" className="p-2  border border-gray-300 rounded-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 w-full" name='labor_price' value={service.labor_price} onChange={(e) => handleChange(index, e)}></input>

                                </div>
                                <img
                                    src={deleteIcon}
                                    style={{ cursor: 'pointer' }}
                                    alt="Clickable area"
                                    className="w-6 h-6 ml-2 mr-2"
                                    onClick={() => handleDelete(index)}
                                />
                            </div>
                            <textarea className='p-2' placeholder='Anotação' name="annotation" onChange={(e) => handleChange(index, e)} value={service.annotation}></textarea>
                        </div>
                    ))}
                </div>
            </div>

            <div className="flex px-3 py-6 h-16 w-full flex-row justify-end items-center gap-4 self-stretch">
                <div onClick={finalizeOS} className="flex h-10 w-36 px-2 py-4 justify-center items-center bg-[#389E0D] gap-2.5 border border-[#389E0D] rounded shadow-sm  cursor-pointer text-white">
                    Finalizar OS
                </div>
                <div className="flex h-10 w-36 px-2 py-4 justify-center items-center bg-[#389E0D] gap-2.5 border border-[#389E0D] rounded shadow-sm  cursor-pointer" onClick={moveOn}>
                    {GlobalSVG.arrowRight()}
                    <p className="text-[#FFF]">Editar</p>
                </div>
            </div>
        </div>
    );
}
export default ChecklistPage;